// extracted by mini-css-extract-plugin
module.exports = {"faq-conatiner":"styles_faq-conatiner__2Qyhw","root":"styles_root__3fIuU"};